import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SimpleFormComponent } from './simple-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { EppPasswordModule } from '../password/password.module';
import { I18nInputModule } from '../config-editor2/i18n-input/i18n-input.module';

@NgModule({
  declarations: [SimpleFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    EppPasswordModule,
    I18nInputModule,
  ],
  exports: [SimpleFormComponent]
})
export class SimpleFormModule { }
